import * as DOM from '../services/dom';
import {scrollAndHighlightElement} from '../services/util';
import {Component} from './component';

function toggleAnchorHighlighting(elementId, shouldHighlight) {
    DOM.forEach(`#page-navigation a[href="#${elementId}"]`, anchor => {
        anchor.closest('li').classList.toggle('current-heading', shouldHighlight);
    });
}

function headingVisibilityChange(entries) {
    for (const entry of entries) {
        const isVisible = (entry.intersectionRatio === 1);
        toggleAnchorHighlighting(entry.target.id, isVisible);
    }
}

function addNavObserver(headings) {
    // Setup the intersection observer.
    const intersectOpts = {
        rootMargin: '0px 0px 0px 0px',
        threshold: 1.0,
    };
    const pageNavObserver = new IntersectionObserver(headingVisibilityChange, intersectOpts);

    // observe each heading
    for (const heading of headings) {
        pageNavObserver.observe(heading);
    }
}

const getCSRFToken = () => {
    const meta = document.querySelector('meta[name="token"]');
    return meta ? meta.getAttribute('content') : '';
}

const createFormData = async () => {
    const formData = new FormData();

    const html = document.querySelector('.page-content div');
    const copyHTML = document.createElement('div');
    copyHTML.innerHTML = html.innerHTML;

    // title should not be sent as content, but instead as a name.
    const title = copyHTML.querySelector('h1.break-text');
    formData.append('name', title.textContent);
    copyHTML.removeChild(title);

    // this element is not part of the page, but it is automatically
    // added in the page view. We need to remove to not submit it as a content.
    const clearLeft = copyHTML.querySelector('div[style="clear:left;"]');
    if (clearLeft && copyHTML.querySelector('div') === clearLeft) {
        copyHTML.removeChild(clearLeft);
    }

    const token = getCSRFToken();
    formData.append('_token', token);
    formData.append('_method', 'PUT');
    formData.append('html', copyHTML.innerHTML);
    return formData;
}

const taskItemCheckboxes = document.querySelectorAll('.task-list-item input[type="checkbox"]');

const addCheckboxesListeners = async () => {
  const setting = await fetch(`${window.location.origin}/setting/app-save-checkboxes-state`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  const { value: saveCheckboxesState } = await setting.json();
  if (saveCheckboxesState === "false" || !saveCheckboxesState) {
    return;
  }

  taskItemCheckboxes.forEach((checkbox) => {
    checkbox.addEventListener("change", async (e) => {
      const checkbox = e.target;
      checkbox.checked ? checkbox.setAttribute("checked", "") : checkbox.removeAttribute("checked");
      const formData = await createFormData();

      await fetch(`${window.location.href}`, {
        method: "POST",
        body: formData,
      });
    });
  });
};

export class PageDisplay extends Component {
    setup() {
        this.container = this.$el;
        this.pageId = this.$opts.pageId;

        window.importVersioned('code').then(Code => Code.highlight());
        this.setupNavHighlighting();

        // Check the hash on load
        if (window.location.hash) {
            const text = window.location.hash.replace(/%20/g, ' ').substring(1);
            this.goToText(text);
        }

        // Sidebar page nav click event
        const sidebarPageNav = document.querySelector('.sidebar-page-nav');
        if (sidebarPageNav) {
            DOM.onChildEvent(sidebarPageNav, 'a', 'click', (event, child) => {
                event.preventDefault();
                window.$components.first('tri-layout').showContent();
                const contentId = child.getAttribute('href').substr(1);
                this.goToText(contentId);
                window.history.pushState(null, null, `#${contentId}`);
            });
        }
        addCheckboxesListeners();
    }

    goToText(text) {
        const idElem = document.getElementById(text);

        DOM.forEach('.page-content [data-highlighted]', elem => {
            elem.removeAttribute('data-highlighted');
            elem.style.backgroundColor = null;
        });

        if (idElem !== null) {
            scrollAndHighlightElement(idElem);
        } else {
            const textElem = DOM.findText('.page-content > div > *', text);
            if (textElem) {
                scrollAndHighlightElement(textElem);
            }
        }
    }

    setupNavHighlighting() {
        const pageNav = document.querySelector('.sidebar-page-nav');

        // fetch all the headings.
        const headings = document.querySelector('.page-content').querySelectorAll('h1, h2, h3, h4, h5, h6');
        // if headings are present, add observers.
        if (headings.length > 0 && pageNav !== null) {
            addNavObserver(headings);
        }
    }

}
